import { useCallback, useEffect, useState } from 'react';

export type ThemePreference = 'light' | 'dark' | 'system';

function apply(pref: ThemePreference) {
  const dark = pref === 'dark' || (pref === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dark);
}

export function useTheme() {
  const [pref, setPref] = useState<ThemePreference>(() => {
    try {
      return (localStorage.getItem('os-theme') as ThemePreference) || 'system';
    } catch {
      return 'system';
    }
  });

  useEffect(() => {
    apply(pref);
    if (pref !== 'system') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const listener = () => apply('system');
    mq.addEventListener('change', listener);
    return () => mq.removeEventListener('change', listener);
  }, [pref]);

  const set = useCallback((next: ThemePreference) => {
    try {
      localStorage.setItem('os-theme', next);
    } catch {
      /* ignore */
    }
    setPref(next);
  }, []);

  return { theme: pref, setTheme: set };
}
